import { registerComponent } from '@gig/magic-common';
import ConfirmationPrompterComponent from './confirmation-prompter.js';

var ConfirmationPrompter = registerComponent(ConfirmationPrompterComponent);

export { ConfirmationPrompter };
